var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-box"},[_c('div',{staticClass:"stat-box-header"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('Scoring'))+" "+_vm._s(_vm.$t('acces_route_rapide')))])]),_c('div',{staticClass:"stat-box-content"},[_c('div',{staticClass:"graph"},[_c('vue-apex-charts',{attrs:{"options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }